import { useEffect } from 'react';
import { toast } from 'react-toastify';

export const useOfflineToast = () => {
    useEffect(() => {
        const toastId = 'offline-warning';

        const showOfflineToast = () => {
            toast.error(
                'We’re having trouble connecting. This could be due to your internet connection or network restrictions. Please check your settings and try again.',
                {
                    toastId,
                    autoClose: false,
                    closeOnClick: false,
                    draggable: false,
                    closeButton: false
                }
            );
        };

        const dismissOfflineToast = () => {
            toast.dismiss(toastId);
        };

        if (!navigator.onLine) {
            showOfflineToast();
        }

        window.addEventListener('offline', showOfflineToast);
        window.addEventListener('online', dismissOfflineToast);

        return () => {
            window.removeEventListener('offline', showOfflineToast);
            window.removeEventListener('online', dismissOfflineToast);
        };
    }, []);
};